import "./Divider.scss"

import React from "react"

const Divider = ({ type = "horizontal"}) => {
    return <hr className={`ns-divider ns-divider-${type}`}/>
}

export default Divider
